<template>
  <div class="root" ref="full_el">
    <header>
      <div class="logo" >
        <img src="../assets/logo.png" alt="" />
        <div class="text">门头沟区历史文化资源数据平台</div>
      </div>
      <div class="user_info" style="display:none;">
        <span v-show="username">
          <span class="fa fa-user-circle-o"></span>{{ username }}
        </span>
        <span v-show="username" @click="login">
          <a>退出</a>
        </span>
        <span v-show="!username" @click="login">
          请您登录
          <a>登录</a>
        </span>
        <span v-show="username" @click="reg()" title="仅管理员有权限创建新用户">
          <a>创建新用户</a>
        </span>
      </div>
      <div class="nav">
        <ul>
          <li>
            <a class="nav-lable" href="http://mtg.chinacul.com">首页</a>
          </li>
          <li>
            <a
              class="nav-lable"
              href="http://192.144.185.209:8099/"
              >地理信息</a
            >
          </li>

          <li>
            <a
              class="nav-lable"
              href="http://mtg.chinacul.com/home/cmap/index.html"
              >文化景观</a
            >
          </li>
          <li>
            <a
              class="nav-lable"
              href="http://mtg.chinacul.com/home/cculturalrelic/cclist.html"
              >文物资源</a
            >
          </li>
           <li>
            <a
              class="nav-lable"
              href="http://mtg.chinacul.com/home/cmapyard/cclist.html"
              >门头沟小院</a
            >
          </li>
                   
          <li>
            <a
              class="nav-lable"
              href="http://mtg.chinacul.com/home/material/index.html"
              >影像资料</a
            >
          </li>
          <li>
            <a
              class="nav-lable"
              href="http://mtg.chinacul.com/home/books/index.html"
              >文献档案</a
            >
          </li>
          <li>
            <a
              class="nav-lable"
              href="http://mtg.chinacul.com/home/cprosee/index.html"
              >产业洞察</a
            >
          </li>
        </ul>
      </div>
    </header>
    <div class="content">
      <div class="tab-contianer">
        <div class="tab active">
          <MapRender></MapRender>
        </div>
      </div>
    </div>
    <div class="footer">
      <span> 门头沟区历史文化资源数据平台</span>
      <div class="icon-group">
        <span class="fa fa-info-circle" @click="toggleLegendPanel()"></span>
        <span class="fa fa-arrows-alt" @click="toggleFullScreen()"></span>
      </div>
      <span id="ol-map-main-coor-id" class="coor"></span>
    </div>
    <FullScreen
      ref="fullBtn"
      :element="screenEl"
      @change="fullChangeFun"
    ></FullScreen>
  </div>
</template>

<script>
import MapRender from "@/components/2DMap/MapRender.vue";
import FullScreen from "./FullScreen";
export default {
  name: "onemap",
  props: {},
  data() {
    return {
      navlist: [],
      selectedTabs: [],
      selectedTab: {},
      screenEl: null,
    };
  },
  computed: {
    username() {
      return this.$store.state.userName;
    },
  },
  methods: {
    goToHome() {
      this.$router.push({ path: "/" });
    },
    fullChangeFun(val) {
      //切换全屏调用的方法
    },
    toggleLegendPanel() {
     //右下角弹出分类导航面板
      this.$store.commit("toggleShowLegendPanel");
    },
    login() {
      this.$cookies.set("access", "", 0);
      this.$cookies.set("refresh", "", 0);
      this.$cookies.set("username", "", 0);
      this.$store.commit("setUserName", "");
      this.$router.push({ path: "/login" });
    },
    reg() {
      let username = this.$cookies.get("username");
      if (username != "admin") {
        this.$message("只有管理员能创建新用户！");
        return;
      }
      this.$router.push({ path: "/register" });
    },
    toggleFullScreen() {
      this.$store.commit("toggleFullScreen");
    },
  },
  components: {
    MapRender,
    FullScreen,
  },
  mounted() {
    this.screenEl = this.$refs.full_el;
  },
};
</script>

<style scoped lang='less'>
.root {
  height: 100%;
  header {
    height: 55px;
    width: 100%;
    color: #fff;
    background-image: url(../assets/pc_header-bg.png);
    background-size: 100% 100%;
    line-height: 55px;
    overflow: hidden;
    .logo {
      display: inline-block;
      padding: 0 10px 0 45px;
      img {
        display: inline-block;
        width: 40px;
        height: 40px;
        margin: 5px 10px 5px 10px;
      }
      .text {
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        font-size: x-large;
        font-family: "楷体", "Arial", "Microsoft YaHei", "宋体", sans-serif;
      }
    }
    .nav {
      padding-left: 10px;
      float: right;
      .fa {
        font-size: large;
      }
      ul {
        padding-inline-start: 10px;
        font-size: 14px;
        margin-left: 0px;
        display: inline-block;
        font-family: "Microsoft YaHei", "宋体", sans-serif;
        li {
          display: inline-block;
          margin: 0 10px;
          .nav-lable {
            color: #ffffff;
            font-size: 14px;
          }
        }
        li:hover {
          cursor: pointer;
          color: #bcc4da;
          text-decoration: underline;
        }
      }
    }
  }
  .content {
    height: calc(100% - 75px);

    .tab-contianer {
      // height: calc(100% - 100px);
      .tab {
        width: 100%;
        height: 100%;
        left: -2000px;
        position: absolute;
      }
      .tab.active {
        left: 0;
      }
    }
  }
}
.user_info {
  float: right;
  margin-right: 20px;
  span {
    padding: 5px;
    margin-right: 5px;
  }
  a {
    color: yellowgreen;
    cursor: pointer;
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 25px;
  line-height: 25px;
  color: #fff;
  text-align: center;
  font-size: small;
  background-color: #193a80;

  .icon-group {
    float: right;
    height: 25px;
    span {
      margin-right: 20px;
      font-size: xx-small;
    }
    span:hover {
      cursor: pointer;
      color: rgb(96, 184, 243);
    }
  }
  .coor {
    float: right;
    height: 25px;
    margin-right: 20px;
  }
}
</style>


